import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-[#E8E5DF]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center group"
        >
          <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_mindcare-clinic-8/artifacts/rw7t280w_CSC%20branding.png"
            alt="Collective Soul Counseling"
            className="h-32 sm:h-40 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9" data-testid="primary-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-body tracking-wide transition-colors ${
                  isActive ? "text-[#6B8E7B]" : "text-[#2E3630] hover:text-[#6B8E7B]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-book-cta"
            className="hidden md:inline-flex btn-pill btn-primary"
          >
            Get in touch
          </Link>
          <button
            type="button"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
            className="md:hidden h-10 w-10 inline-flex items-center justify-center rounded-full border border-[#E8E5DF] text-[#2E3630]"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#E8E5DF]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-serif-display text-2xl ${
                    isActive ? "text-[#6B8E7B]" : "text-[#2E3630]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-book-cta"
              className="btn-pill btn-primary w-fit mt-2"
            >
              Get in touch
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
